import { AuthAccount } from '..';

export type NullTime = string;

export type NullDate = string;

export type ID = string;
export const DEFAULT_ID: ID = '';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ResponseData<T = any> {
  status: number;
  message: string;
  error_message: string;
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
  data: T;
  sections: Section[];
  paging: Paging;
}

export interface Paging {
  page: number;
  per_page: number;
  total_count: number;
}

export interface Section {
  key: string;
  index: number;
}

// swagger:model
export interface ModelBasic {
  id: ID;
  created_by?: AuthAccount;
  updated_by?: AuthAccount;
  created_at?: Date;
  updated_at?: Date;
}

export interface KeyLabel {
  key: string;
  label: string;
}

export interface TypeSelection {
  id: ID;
  name: string;
  type: string;
}

export interface ModelError {
  origin_type: string;
  origin_id: ID;
  error_code: number;
  error_message: string;
  error_info: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error_data: any;
}

export interface DataUrlConfig {
  data_url_list: string;
  data_url: string;
  data_url_questions: string;
  data_url_question_filter_stats: string;
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'dd.MM.yyyy', // Format für das Datum, das vom Benutzer eingegeben wird
  },
  display: {
    dateInput: 'dd.MM.yyyy', // Format für die Anzeige des Datums
    monthYearLabel: 'MMM yyyy', // Format für die Monat-Jahr-Angabe
    dateA11yLabel: 'dd.MM.yyyy', // Format für die barrierefreie Label des Datums
    monthYearA11yLabel: 'MMMM yyyy', // Format für die barrierefreie Label des Monats-Jahr
  },
};
